// extracted by mini-css-extract-plugin
module.exports = {"pendingLeadsContainer":"pendingLeads_pendingLeadsContainer__pIg2v","separator":"pendingLeads_separator__FaeeF","showMoreAgents":"pendingLeads_showMoreAgents__hmBIZ"};